import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="skeleton"
            className={cn('animate-pulse rounded-xl dark:bg-foreground/10 light:bg-surface', className)}
            {...props}
        />
    );
}

export { Skeleton };
